<div class="legal-privacy-policy-container">
	<mat-expansion-panel class="privacy-policy-section" [expanded]="true">
		<mat-expansion-panel-header collapsedHeight="24px" expandedHeight="24px"
			class="privacy-policy-section-title">
			<mat-panel-title translate>settings.privacypolicy.PrivacyPolicy</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="privacy-policy-section-body section-first-body">
				<span translate>settings.privacypolicy.PrivacyPolicyContent</span>&nbsp;
				<a class="privacy-policy-section-body-link" target="_blank"
					href="http://corporate.arcelormittal.com/investors/corporate-governance/our-policies"
					translate>settings.privacypolicy.amwebsite</a>
			</div>
		</ng-template>
	</mat-expansion-panel>

	<mat-expansion-panel class="privacy-policy-section" [expanded]="true">
		<mat-expansion-panel-header collapsedHeight="24px" expandedHeight="24px"
			class="privacy-policy-section-title">
			<mat-panel-title translate>settings.privacypolicy.GeneralInformation</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="privacy-policy-section-body section-first-body">
				<span translate>settings.privacypolicy.GeneralInformationWebservices</span>
			</div>
			<div class="privacy-policy-section-body">
				<span translate>settings.privacypolicy.GeneralInformationProperty</span>
			</div>
		</ng-template>
	</mat-expansion-panel>

	<mat-expansion-panel class="privacy-policy-section" [expanded]="true">
		<mat-expansion-panel-header collapsedHeight="24px" expandedHeight="24px"
			class="privacy-policy-section-title">
			<mat-panel-title translate>settings.privacypolicy.PersonalInformation</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="privacy-policy-section-body section-first-body">
				<span translate>settings.privacypolicy.PersonalInformationContent</span>
			</div>
		</ng-template>
	</mat-expansion-panel>

	<mat-expansion-panel class="privacy-policy-section" [expanded]="true">
		<mat-expansion-panel-header collapsedHeight="24px" expandedHeight="24px"
			class="privacy-policy-section-title">
			<mat-panel-title translate>settings.privacypolicy.usedataprovided</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="privacy-policy-section-body section-first-body">
				<span translate>settings.privacypolicy.UseDataProvidedResponses</span>
			</div>
			<div class="privacy-policy-section-body">
				<span translate>settings.privacypolicy.UseDataProvidedConsultrectify</span>&nbsp;
				<a class="privacy-policy-section-body-link"
					href="mailto:ebusiness.support@arcelormittal.com">ebusiness.support&#64;arcelormittal.com</a>
			</div>
		</ng-template>
	</mat-expansion-panel>

	<mat-expansion-panel class="privacy-policy-section" [expanded]="true">
		<mat-expansion-panel-header collapsedHeight="24px" expandedHeight="24px"
			class="privacy-policy-section-title">
			<mat-panel-title translate>settings.privacypolicy.usecookies</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="privacy-policy-section-body section-first-body">
				<span translate>settings.privacypolicy.UseCookiesInstalled</span>
			</div>
			<div class="privacy-policy-section-body">
				<span translate>settings.privacypolicy.UseCookiesNavigation</span>&nbsp;
				<a class="privacy-policy-section-body-link"
					href="mailto:ebusiness.support@arcelormittal.com">ebusiness.support&#64;arcelormittal.com</a>
			</div>
			<ul class="privacy-policy-section-body">
				<li>
					<span translate>settings.privacypolicy.ifyouareusing</span>&nbsp;
					<span>Internet Explorer 11</span>:
					<a class="privacy-policy-section-body-link" target="_blank"
						href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies"
						translate>global.clickhere</a>
				</li>
				<li>
					<span translate>settings.privacypolicy.ifyouareusing</span>&nbsp;
					<span>Mozilla Firefox</span>:
					<a class="privacy-policy-section-body-link" target="_blank"
						href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
						translate>global.clickhere</a>
				</li>
				<li>
					<span translate>settings.privacypolicy.ifyouareusing</span>&nbsp;
					<span>Google Chrome</span>:
					<a class="privacy-policy-section-body-link" target="_blank"
						href="https://support.google.com/chrome/answer/95647?hl=en" translate>global.clickhere</a>
				</li>
			</ul>
			<div class="privacy-policy-section-body">
				<span translate>settings.privacypolicy.UseCookiesRefusing</span>
			</div>
		</ng-template>
	</mat-expansion-panel>

	<mat-expansion-panel class="privacy-policy-section" [expanded]="true">
		<mat-expansion-panel-header collapsedHeight="24px" expandedHeight="24px"
			class="privacy-policy-section-title">
			<mat-panel-title translate>settings.privacypolicy.UseGoogleAnalytics</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="privacy-policy-section-body section-first-body">
				<span translate>settings.privacypolicy.UseCookiesInstalled</span>
			</div>
			<div class="privacy-policy-section-body">
				<span translate>settings.privacypolicy.UseGoogleAnalyticsContent</span>&nbsp;
				<a class="privacy-policy-section-body-link" target="_blank"
					href="https://www.google.com/policies/privacy/partners/">www.google.com/policies/privacy/partners/</a>
			</div>
		</ng-template>
	</mat-expansion-panel>

	<mat-expansion-panel class="privacy-policy-section" [expanded]="true">
		<mat-expansion-panel-header collapsedHeight="24px" expandedHeight="24px"
			class="privacy-policy-section-title">
			<mat-panel-title translate>settings.privacypolicy.Protection</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="privacy-policy-section-body section-first-body">
				<span translate>settings.privacypolicy.ProtectionSecrecy</span>
			</div>
			<div class="privacy-policy-section-body">
				<span translate>settings.privacypolicy.ProtectionCommunication</span>
			</div>
			<div class="privacy-policy-section-body">
				<span translate>settings.privacypolicy.Protection2years</span>
			</div>
			<div class="privacy-policy-section-body">
				<span translate>settings.privacypolicy.ProtectionAbuse</span>
			</div>
			<div class="privacy-policy-section-body">
				<span translate>settings.privacypolicy.ProtectionResponsible</span>
			</div>
		</ng-template>
	</mat-expansion-panel>

	<mat-expansion-panel class="privacy-policy-section" [expanded]="true">
		<mat-expansion-panel-header collapsedHeight="24px" expandedHeight="24px"
			class="privacy-policy-section-title">
			<mat-panel-title translate>settings.privacypolicy.Property</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="privacy-policy-section-body section-first-body">
				<span translate>settings.privacypolicy.PropertyContent</span>
			</div>
		</ng-template>
	</mat-expansion-panel>

	<mat-expansion-panel class="privacy-policy-section" [expanded]="true">
		<mat-expansion-panel-header collapsedHeight="24px" expandedHeight="24px"
			class="privacy-policy-section-title">
			<mat-panel-title translate>settings.privacypolicy.Worldwidetransfer</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="privacy-policy-section-body section-first-body">
				<span translate>settings.privacypolicy.worldwidetransfercontent</span>
			</div>
		</ng-template>
	</mat-expansion-panel>

	<mat-expansion-panel class="privacy-policy-section" [expanded]="true">
		<mat-expansion-panel-header collapsedHeight="24px" expandedHeight="24px"
			class="privacy-policy-section-title">
			<mat-panel-title translate>settings.privacypolicy.hypertextlinks</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="privacy-policy-section-body section-first-body">
				<span translate>settings.privacypolicy.HypertextLinksContent</span>
			</div>
		</ng-template>
	</mat-expansion-panel>

	<mat-expansion-panel class="privacy-policy-section" [expanded]="true" id="credits">
		<mat-expansion-panel-header collapsedHeight="24px" expandedHeight="24px"
			class="privacy-policy-section-title">
			<mat-panel-title translate>settings.privacypolicy.creditsforpictures</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="privacy-policy-section-body section-first-body">
				<span><a class="privacy-policy-section-body-hover" href="#" (click)="$event.preventDefault();downloadImage('BL')" translate>global-subcategory.BL</a> - © Han maomin / Shutterstock.com</span>
			</div>
			<div class="privacy-policy-section-body">
				<span><a class="privacy-policy-section-body-hover" href="#" (click)="$event.preventDefault();downloadImage('PI')" translate>global-subcategory.PI</a> - © Bernard Mikolajczak</span>
			</div>
			<div class="privacy-policy-section-body">
				<span><a class="privacy-policy-section-body-hover" href="#" (click)="$event.preventDefault();downloadImage('CR')" translate>global-subcategory.CR</a> - © Jeroen Op de Beeck</span>
			</div>
			<div class="privacy-policy-section-body">
				<span><a class="privacy-policy-section-body-hover" href="#" (click)="$event.preventDefault();downloadImage('ZM')">Magnelis</a><sup>®</sup> - © MAXSHOT.PL / Shutterstock.com</span>
			</div>
			<div class="privacy-policy-section-body">
				<span><a class="privacy-policy-section-body-hover" href="#" (click)="$event.preventDefault();downloadImage('ZVI')">Jetskin</a><sup>®</sup> - © Philippe Vandenameele</span>
			</div>
			<div class="privacy-policy-section-body">
				<span><a class="privacy-policy-section-body-hover" href="#" (click)="$event.preventDefault();downloadImage('Z')" translate>global-subcategory.Z</a> - © David Dalla Costa / Shutterstock.com</span>
			</div>
			<div class="privacy-policy-section-body">
				<span><a class="privacy-policy-section-body-hover" href="#" (click)="$event.preventDefault();downloadImage('MS')" translate>global-subcategory.MS</a> - © Roman023_photography / Shutterstock.com</span>
			</div>
		</ng-template>
	</mat-expansion-panel>

	<mat-expansion-panel class="privacy-policy-section" [expanded]="true">
		<mat-expansion-panel-header collapsedHeight="24px" expandedHeight="24px"
			class="privacy-policy-section-title">
			<mat-panel-title translate>settings.privacypolicy.responsabilities</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="privacy-policy-section-body section-first-body">
				<span translate>settings.privacypolicy.ResponsabilitiesContent</span>
			</div>
		</ng-template>
	</mat-expansion-panel>

	<mat-expansion-panel class="privacy-policy-section" [expanded]="true">
		<mat-expansion-panel-header collapsedHeight="24px" expandedHeight="24px"
			class="privacy-policy-section-title">
			<mat-panel-title translate>settings.privacypolicy.ContactUs</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="privacy-policy-section-body section-first-body">
				<span translate>settings.privacypolicy.ContactUsPlease</span>
			</div>
			<div class="privacy-policy-section-body">
				<span translate>settings.privacypolicy.ContactUsAddress</span>
			</div>
			<div class="privacy-policy-section-body">
				<span translate>settings.privacypolicy.ContactUsByEmail</span>&nbsp;
				<a class="privacy-policy-section-body-link"
					href="mailto:ebusiness.support@arcelormittal.com">ebusiness.support&#64;arcelormittal.com</a>
			</div>
		</ng-template>
	</mat-expansion-panel>
</div>